"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  primary: {
    root: {
      backgroundColor: 'red'
    },
    header: {},
    title: {},
    close: {},
    body: {}
  },
  fullscreen: {
    root: {},
    header: {},
    title: {},
    close: {},
    body: {}
  }
};
exports.default = _default;